/**
 * The one rule for turning a page title into the <title> string.
 *
 * Used by hooks/useSEO.js at runtime and by scripts/inject-seo-heads.js at
 * build time — the same two-writers problem as blogJsonLd.js and cityTitle.js.
 *
 * Why the brand suffix is conditional: Google truncates the title link at
 * roughly 600px, near 60 characters. " | Buy Sell Taxi" costs 16 of those. On
 * 2026-09-23, 142 of the 164 sitemapped pages were over the limit WITH the
 * suffix and only 36 were over it without — so on ~106 pages the brand was the
 * thing pushing the useful words out of the SERP. Google appends the site name
 * itself when it wants one, and truncated titles are a measured CTR loss.
 *
 * Long titles still need shortening; this rule only stops the brand from being
 * the cause. Keep the file import-free and every declaration a top-level
 * export — the injector loads it by stripping the `export` keywords.
 */
export const SITE_NAME = 'Buy Sell Taxi';

// Characters, as a stand-in for the ~600px Google actually measures. Titles at
// or under this keep the brand; over it, the page's own words win.
export const TITLE_LIMIT = 60;

export function fullTitle(title) {
  if (!title) return `${SITE_NAME} – Buy & Sell Commercial Vehicles in India`;
  // Pages that name the brand themselves (the homepage, /about) never get it
  // twice.
  if (title.includes(SITE_NAME)) return title;
  const withBrand = `${title} | ${SITE_NAME}`;
  return withBrand.length <= TITLE_LIMIT ? withBrand : title;
}
